module.exports = __webpack_public_path__ + "static/media/42.114b57db.png";